import React from "react";
import { PopupButton } from "@typeform/embed-react";

export default function MainHeader() {
    return (
        <nav className="navbar navbar-expand-lg pageNavbar">
            <div className="container">
                <a className="navbar-brand" href="/">
                    <img
                        src={`${process.env.PUBLIC_URL}/img/logo.svg`}
                        alt=""
                    />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Company{" "}
                                <i className="fa-solid fa-chevron-down"></i>
                            </a>
                            <ul
                                className="dropdown-menu"
                                aria-labelledby="navbarDropdown"
                            >
                                <li>
                                    <a
                                        className="dropdown-item"
                                        href="/about-us"
                                    >
                                        About Us
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="dropdown-item"
                                        href="/features"
                                    >
                                        Features
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                aria-current="page"
                                href="/pricing"
                            >
                                Pricing
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/login">
                                Login
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link mainBtn" href="/signup">
                                SIGN UP
                            </a>
                        </li>
                        <li className="nav-item">
                            <PopupButton
                                id="wGivzOug"
                                className="nav-link mainBtn outLine"
                            >
                                REQUEST DEMO
                            </PopupButton>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}
